import React from "react";
import cx from "classnames";

// Display a single message in a colored box based on the type, but without a container
export function Message(props) {
    return props.message ? (
        <div className={cx("alert", props?.type ? `alert-${props.type}` : "")}>
            <p>{props.message}</p>
        </div>
    ) : null;
}

// Display multiple messages in a container which takes 12 column grid layout as width
export function Messages(props) {
    return (
        <div className="row">
            <div className="col-12">
                {props?.messages?.map((item, idx) => (
                    <Message {...item} key={idx} />
                ))}
            </div>
        </div>
    );
}
